/* es6-weak-map/implement */ function _(require, module, exports) {
    if (!require(390) /* ./is-implemented */()) {
        Object.defineProperty(require(329) /* es5-ext/global */, 'WeakMap', { value: require(392) /* ./polyfill */, configurable: true, enumerable: false,
            writable: true });
    }
}
